module.exports = __webpack_public_path__ + "static/media/frankfurter.c1861db8.png";